// extracted by mini-css-extract-plugin
export default {"container":"MapVenueCard_container__OSeyG","bottom":"MapVenueCard_bottom__iU4wO","cardOverride":"MapVenueCard_cardOverride__Ydg1Z"};